<template>
  <div id="app">
    <div class="splash" v-if="splash">
      <!-- eslint-disable -->
      <svg id="icon" viewBox="0 0 300 378">
        <g>
          <path d="M150,0 C232.842712,0 300,69.5819791 300,155.4157 C300,202.94789 279.405421,245.496291 246.956975,274.001001 C242.357104,233.478072 209.096948,202.04041 168.75,202.04041 C144.182406,202.04041 126.345304,215.006452 82.4310254,238.973059 C64.5778815,248.716571 41.8084304,261.495119 24.8899873,240.935237 C24.7040193,240.709242 24.5175284,240.494465 24.3268102,240.296913 C8.94263114,215.894839 0,186.737307 0,155.4157 C0,69.5819791 67.1572875,0 150,0 Z M161.224064,108.79099 C135.052281,108.79099 112.5,127.6202 112.5,149.438173 C112.5,166.773001 125.585891,178.728055 143.961824,178.728055 C163.173026,178.728055 183.776345,165.27862 191.850618,147.644915 C194.584228,141.531535 196.164155,135.360315 193.958695,127.572016 C192.488388,122.379816 188.908656,117.813107 183.219498,113.871888 C175.980495,109.986496 170.133607,108.79099 161.224064,108.79099 Z"></path>
        </g>
      </svg>
      <!-- eslint-enable -->
    </div>
  <router-view name="nav" :key="$i18n.locale"></router-view>
    <div class="page-wrapper">
      <router-view name="notice" :class="this.$route.name"></router-view>
      <div class="content-wrapper has-background-white-bis">

        <div class="pan-area"
          v-if="!openBar"
          @click="() => setStatePlayerCard(true)"
          @touchstart="touchstart"
          @touchmove="touchmove"
        >
          <div class="player-card-pan-bar is-hidden-desktop"></div>
          <div class="player-card-pan-close is-hidden-touch">
            <b-button
              @click="() => setStatePlayerCard(true)"
              type="is-ghost"
              icon-pack="fas" icon-right="times"
              size="is-medium"
              class="has-text-white"
            />
          </div>
        </div>

        <!--mobile safearea holder-->
        <div
          :class="[openBar ? isVideoPage ? '' : 'mobile-bottombar-holder' : 'player-card-bg']"
        >
        <!-- For Floating video-->
        <transition name="player">
        <div
          :class="[openBar ? isVideoPage ? 'fixspace' : 'player-warp playerbg' : 'player-card']"
          v-show="isVideoPage || player.videoId"
          :data-open="openBar === true ? 1 : 0"
        >
          <div
            :class="[openBar ? isVideoPage ?
            'is-hidden-mobile' : 'pt-3 is-hidden-touch' : 'pt-6 is-hidden-touch']"
          >
          </div>
          <div :class="(isVideoPage ? 'container is-max-desktop' : 'container')">
            <div
              :class="[openBar ? isVideoPage ?
              'columns is-gapless is-vcentered is-mobile' :
              'columns is-gapless is-vcentered is-mobile' : '']"
            >
              <div
                :class="[openBar ? isVideoPage ? 'column' : 'column is-1-desktop is-4-mobile' : '']"
              >
                <figure
                  :class="(isVideoPage ? 'image is-16by9 shadowed' : 'image is-16by9')"
                  v-if="isInitPlayer">
                  <div class="player-frame-bg"></div>
                  <youtube
                    ref="videoPlayer"
                    class="has-ratio player-main"
                    width="100%"
                    height="100%"
                    :video-id="player.videoId"
                    :player-vars="playerVars"
                    :fitParent="true"
                    :resize="true"
                    :resize-delay="200"
                    @playing="playing"
                    @pause="pausing"
                    @ended="ended"></youtube>
                </figure>
              </div>

              <div :class="(isVideoPage ? '' : 'mx-2 is-hidden-mobile')"></div>

              <player-card v-if="!openBar"></player-card>

              <div class="column is-three-quarters-desktop is-4-mobile is-size-7 ml-2"
                v-if="currentVideo && !isVideoPage && openBar"
                v-on:click="openBar = !openBar"
                @click="openPlayerCard()">
                  <p class="is-text-overflow has-text-weight-semibold has-text-black">
                    {{ currentVideo.title }}
                  </p>
                  <p class="is-text-overflow has-text-grey">
                    {{ currentVideo ? currentVideo.channel.title : '' }}
                  </p>
              </div>
              <div class="column" v-if="currentVideo && !isVideoPage && openBar">
                <div class="buttons has-addons is-right mr-1">
                  <b-tooltip :label="$t('player.pause')" type="is-dark" :delay="500" square>
                    <button
                      class="button is-text is-small"
                      style="text-decoration:none;"
                      @click="playVideo">
                        <span class="icon is-small">
                          <i :class="isPlaying ? 'fas fa-pause': 'fas fa-play'"></i>
                        </span>
                    </button>
                  </b-tooltip>
                  <div class="pr-1 is-hidden-mobile"></div>
                  <b-tooltip :label="$t('player.next')" type="is-dark" :delay="500" square>
                    <button
                      class="button is-text is-small"
                      @click="playNext(), clickNextVideo()"
                      style="text-decoration:none;">
                      <span class="icon is-small">
                        <i class="fas fa-step-forward"></i>
                      </span>
                    </button>
                  </b-tooltip>
                  <div class="pr-1 is-hidden-mobile"></div>
                  <b-tooltip :label="$t('player.close')" type="is-dark" :delay="500" square>
                    <button
                      class="button is-text is-small"
                      @click="closePlayer"
                      style="text-decoration:none;">
                        <span class="icon is-small">
                          <i class="fas fa-eject"></i>
                        </span>
                    </button>
                  </b-tooltip>
                </div>
              </div>
            </div>
          </div>
          <div class="pb-3 is-hidden-touch"></div>
        </div>
        </transition>

        <!--mobile global tabbar hidden videopage-->
        <router-view name="tabbar"
          :class="(isVideoPage ? 'is-hidden' : 'tabbar-warp has-background-white is-hidden-tablet')"
        ></router-view>

        </div>

        <!--main view-->
        <router-view :key="$i18n.locale" @forGtagStatus="forGtagfetchStatusContent"></router-view>
        <!--mobile padding bottom-->
        <div class="is-hidden-tablet pt-4 pb-6"></div>
      </div>

      <!--videopage tabbar-->
      <router-view name="tabbar"
        :class="(isVideoPage ?
        'video-tabbar-warp has-background-white is-hidden-tablet' : 'is-hidden')">
      </router-view>
      <!--mobile safearea holder bottom blank bg-->
      <div class="mobile-safebg has-background-white is-hidden-tablet"></div>

    <router-view name="footer" :key="$i18n.locale" class="is-hidden-mobile"></router-view>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { bootstrap } from 'vue-gtag';
import WebFont from 'webfontloader';
import store from '@/store';
import Vue from 'vue';
import VueYoutube from 'vue-youtube';

Vue.use(VueYoutube);

const playerCard = () => import('./components/PlayerCard.vue');

export default {
  name: 'App',
  components: { playerCard },

  metaInfo() {
    return {
      title: 'Musian - Discover the World’s Top Artist & Performance works',
      titleTemplate: '%s - Musian',
      htmlAttrs: {
        lang: this.$i18n.locale,
      },
      meta: [
        { property: 'og:title', vmid: 'og:title', content: this.$t('general.explore') },
        { property: 'og:description', vmid: 'og:description', content: this.$t('msgs.explorehero3') },
        { property: 'og:url', vmid: 'og:url', content: 'https://musian.app' },
        { property: 'og:locale', vmid: 'og:locale', content: this.$i18n.locale },
        { property: 'og:image', vmid: 'og:image', content: 'https://musian.app/assets/open_graph_logo.jpg' },
        { property: 'og:type', vmid: 'og:type', content: 'website' },
        { property: 'og:site_name', vmid: 'og:site_name', content: this.$i18n.locale },
      ],
    };
  },

  data() {
    return {
      splash: true,
      openBar: true,

      isInitPlayer: false,
      playerVars: {
        autoplay: 1,
        loop: 1,
        fs: 1,
        rel: 0,
        controls: 1,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
      },

      isPlaying: false,
      isShowMiniPlayer: null,
    };
  },
  computed: {
    ...mapGetters({
      player: 'player',
    }),

    currentVideo() {
      if (!this.player.videoId) {
        return null;
      }

      return this.player.queue[this.player.currentPlayIndex];
    },

    isVideoPage() {
      return (this.$route.name === 'VideoPage');
    },

    mainPlayer() {
      return this.$refs.videoPlayer;
    },
  },

  created() {
  },

  async mounted() {
    this.isInitPlayer = true;
    this.$nextTick().then(() => {
      if (this?.mainPlayer?.player !== undefined) {
        this.mainPlayer.player.addEventListener('onStateChange', this.youtubeControl);
        store.dispatch('setPlayerComponent', { playerObject: this.mainPlayer });
      }
    });

    WebFont.load({
      google: {
        families: this.getFontFamilies(),
      },
      timeout: 3000,
    });

    this.sendGtag();
    this.timer = setInterval(this.sendGtagUse, 300000);

    this.timeout = setTimeout(() => { this.splash = false; }, 1800);
  },

  beforeDestroy() {
    clearTimeout(this.timer);
    clearInterval(this.timer);
  },

  methods: {
    setStatePlayerCard(show) {
      this.openBar = show;
      console.debug(this.openBar);
    },
    openPlayerCard() {
      this.$gtag.event('open_player_card', {
        event_category: 'mini_player',
        event_label: 'User open player card',
        value: 1,
      });
    },
    touchstart(e) {
      this.startX = e.touches[0].clientX;
      this.startY = e.touches[0].clientY;
    },
    touchmove(e) {
      this.moveX = e.touches[0].clientX;
      this.moveY = e.touches[0].clientY;
      // this.startY - this.moveY;
      if (this.startY - this.moveY <= -50) {
        this.openBar = true;
        console.debug(this.openBar);
      }
    },

    forGtagfetchStatusContent(result) {
      this.fetchContent = result;
      this.$emit('optionGtag', this.fetchContent);
    },

    sendGtag() {
      this.$once('optionGtag', (value) => {
        this.timers = setTimeout(() => {
          bootstrap().then(() => {
            this.$gtag.pageview({
              page_title: `${value} - Musian`,
              page_path: this.$route.path,
            });
          });
        }, 200);
      });
    },

    sendGtagUse() {
      console.debug('use');
      this.$gtag.event('operation_use', {
        event_category: 'general_operation',
        event_label: 'User browse the page',
        value: 1,
      });
    },

    getFontFamilies() {
      const lang = this.$i18n.locale || 'en-US';
      const families = ['Roboto:300,400,500,700,900', 'Noto Sans JP:300,400,500,700,900'];

      if (lang === 'zh-TW') {
        families.push('Noto Sans TC:300,400,500,700,900');
      }

      if (lang === 'zh-CN') {
        families.push('Noto Sans SC:300,400,500,700,900');
      }

      return families;
    },

    youtubeControl(state) {
      this.isPlaying = (state.data === 1);
      store.dispatch('setPlayerState', { state: state.data });
    },

    playObject() {
      return this.$refs.videoPlayer.player;
    },

    ended() {
      this.playNext();
    },

    playNext() {
      this.player.currentPlayIndex += 1;

      if (this.player.currentPlayIndex >= this.player.queue.length) {
        this.player.currentPlayIndex = 0;
      }

      store.dispatch('setPlayerCurrentPlay', { index: this.player.currentPlayIndex });
    },

    clickNextVideo() {
      this.$gtag.event('playbar_next', {
        event_category: 'mini_player',
        event_label: 'User clicked next video mini player',
        value: 1,
      });
    },

    async playVideo() {
      if (this.isPlaying) {
        await this.playObject().pauseVideo();

        this.$gtag.event('playbar_pause', {
          event_category: 'mini_player',
          event_label: 'User clicked pause video mini player',
          value: 1,
        });
      } else {
        await this.playObject().playVideo();

        this.$gtag.event('playbar_play', {
          event_category: 'mini_player',
          event_label: 'User clicked play video mini player',
          value: 1,
        });
      }
    },

    closePlayer() {
      this.player.videoId = null;
      this.player.queue = [];
      this.player.currentPlayIndex = 0;

      this.$gtag.event('playbar_close', {
        event_category: 'mini_player',
        event_label: 'User clicked close mini player',
        value: 1,
      });
    },

    playing() {
      this.$gtag.event('video_play', {
        event_category: 'player_control',
        event_label: 'Video playing',
        value: 1,
      });
      console.debug('playing');
    },

    pausing() {
      console.debug('pausing');
    },
  },
};
</script>

<style lang="scss">
html, body {
  font-family: "Roboto", "Noto Sans JP", "Noto Sans TC", "Noto Sans SC",
  BlinkMacSystemFont, -apple-system, "Segoe UI", "Oxygen", "Ubuntu",
  "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  background: rgb(255,255,255);
  background: -moz-linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(0,0,0,1) 50%);
  background: -webkit-linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(0,0,0,1) 50%);
  background: linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(0,0,0,1) 50%);
  -webkit-user-select: none;
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
}
html:lang(ja-JP) body {
  font-family: "Roboto", "Noto Sans JP", "Noto Sans TC", "Noto Sans SC",
  BlinkMacSystemFont, -apple-system, "Segoe UI", "Helvetica Neue", "Arial", sans-serif;
}
html:lang(zh-TW) body {
  font-family: "Roboto", "Noto Sans TC", "Noto Sans JP", "Noto Sans SC",
  BlinkMacSystemFont, -apple-system, "Segoe UI", "Helvetica Neue", "Arial", sans-serif;
}
html:lang(zh-CN) body {
  font-family: "Roboto", "Noto Sans SC", "Noto Sans JP", "Noto Sans TC",
  BlinkMacSystemFont, -apple-system, "Segoe UI", "Helvetica Neue", "Arial", sans-serif;
}

.splash {
  background: #fafafa;
  position: fixed;
  z-index: 9999;
  width: 100%;
  height: 100%;
  opacity: 0;
  animation: fade-out 1.5s;
}
.splash #icon {
  --size: 100px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: var(--size);
  fill: rgb(20, 20, 20);

  animation: zoom-in 1.5s;
  animation-delay: 1.5s;
}
@keyframes zoom-in {
  50% {
    width: var(--size);
  }
  60% {
    width: calc(var(--size) * 0.9);
  }
  100% {
    width: 250%;
  }
}
@keyframes fade-out {
  0%,
  85% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

#app {
  background-color: #000;
  padding-top: constant(safe-area-inset-top);
  padding-top: env(safe-area-inset-top);
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}
.page-wrapper {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
}
.content-wrapper {
  flex: 1;
}

.fixspace {
    padding-top: 3.25rem;
  }
.servicenotice {
    position: relative;
    z-index: 1;
    top: 3.25rem;
  }

@media screen and (min-width: 769px) {
  .fixspace {
    padding-top: 72px;
  }
  .servicenotice {
    position: relative;
    z-index: 1;
    top: 72px;
  }
}

.servicenotice.Signin, .servicenotice.Joinbeta {
  display: none;
}

.is-text-overflow {
  display: block;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
}
.text-offset {
  line-height: 1.6;
}
.card {
  border-radius: 0.3rem;
}
.card-image:first-child img,
.card-image:last-child img,
.card-footer:first-child,
.card-footer:last-child,
.card-content:last-child  {
    border-radius: 0.3rem;
}
.card-content {
  transition: .3s;
}
.card-content:hover {
  background-color: rgba(0,0,0,0.0) !important;
  transition: .3s;
}

.shadowed {
  box-shadow: 0 20px 40px -20px #333;
}

.mobile-bottombar-holder {
  position: fixed;
  z-index: 10;
  width: 100%;
  bottom: 0;
  left: 0;
  margin-bottom: constant(safe-area-inset-bottom);
  margin-bottom: env(safe-area-inset-bottom);
}
.mobile-safebg {
  position: fixed;
  z-index: 9;
  width: 100%;
  height: 35px;
  bottom: 0;
  left: 0;
}
.tabbar-warp {
  position: absolute;
  z-index: 11;
  width: 100%;
  height: 50px;
  border-top: 2px solid rgba(201, 201, 201, 0.72);
  bottom: 0;
  left: 0;
}
.video-tabbar-warp {
  z-index: 11;
  position: fixed;
  width: 100%;
  height: 50px;
  border-top: 2px solid rgba(201, 201, 201, 0.72);
  bottom: constant(safe-area-inset-bottom);
  bottom: env(safe-area-inset-bottom);
  left: 0;
}

.player-warp {
  position: absolute;
  z-index: 11;
  width: 100%;
  bottom: 50px;
  left: 0;
  border-top: 2px solid rgba(201, 201, 201, 0.72);

  -webkit-animation: .30s ease-in-out 0s normal none 1 running fadeInUp;
  animation: .30s ease-in-out 0s normal none 1 running fadeInUp;
  -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  // -webkit-box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.1);
  // box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.1);

  /* not mobile setting below*/
  @media (min-width: 768px) {
    position: fixed;
    bottom: 0;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
}

.player-card-pan-bar {
  width: 45px;
  height: 8px;
  border-radius: 14px;
  background: #fff;
  margin: 0 auto;
  cursor: pointer;
}
.player-card-pan-close {
  margin-right: 10px;
  right: 0;
  position: fixed;
  z-index: 38;
  top: 0;
  cursor: pointer;
}
.pan-area {
  padding: 22px 0;
  width: 100%;
  position: fixed;
  z-index: 37;
  top: 0;
  -webkit-animation-name: playerCardfadeInUp;
  animation-name: playerCardfadeInUp;
  -webkit-animation-duration: 0.3s;
  animation-duration: 0.3s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-transition: all 0.3s cubic-bezier(.17,.67,.83,.67);
  transition: all 0.3s cubic-bezier(.17,.67,.83,.67);
}
.player-card-bg {
  display: block;
  // transition: all .3s;
  position: fixed;
  z-index: 35;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, .5);
}
.player-card {
  position: absolute;
  z-index: 36;
  height: 100vh;
  width: 100%;
  top: 0;
  left: 0;
  background: #fafafa;
  border-radius: 10px 10px 0 0;
  margin-top: 2.5rem;
  overflow-y: scroll;
  -webkit-animation-name: playerCardfadeInUp;
  animation-name: playerCardfadeInUp;
  -webkit-animation-duration: 0.3s;
  animation-duration: 0.3s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-transition: all 0.3s cubic-bezier(.17,.67,.83,.67);
  transition: all 0.3s cubic-bezier(.17,.67,.83,.67);
}
@-webkit-keyframes playerCardfadeInUp {
  0% {
  opacity: 0;
  -webkit-transform: translate3d(0, 100%, 0);
  transform: translate3d(0, 100%, 0);
  }
  100% {
  opacity: 1;
  -webkit-transform: none;
  transform: none;
  }
  }
  @keyframes playerCardfadeInUp {
  0% {
  opacity: 0;
  -webkit-transform: translate3d(0, 100%, 0);
  transform: translate3d(0, 100%, 0);
  }
  100% {
  opacity: 1;
  -webkit-transform: none;
  transform: none;
  }
}
.player-leave {
  opacity: 1;
}
.player-leave-active {
  -webkit-animation: slide-bottom 0.5s ease-out forwards;
  animation: slide-bottom 0.5s ease-out forwards;
  -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.player-leave-to {
  opacity: 0;
}
@-webkit-keyframes slide-bottom {
  0% {
    -webkit-transform: translateY(0);
            transform: translateY(0);
  }
  100% {
    -webkit-transform: translateY(100px);
            transform: translateY(100px);
  }
}
@keyframes slide-bottom {
  0% {
    -webkit-transform: translateY(0);
            transform: translateY(0);
  }
  100% {
    -webkit-transform: translateY(100px);
            transform: translateY(100px);
  }
}

.player-main::v-deep{
  max-width: 100%;
  max-height: 100%;
}
.playerbg {
  -webkit-backdrop-filter: saturate(180%) blur(20px);
  backdrop-filter: saturate(180%) blur(20px);
  background-color: rgba(255,255,255,0.72);
}
.player-frame-bg {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  background-color: #b8b3b3;
}

.skeleton {
  .skeleton-block {
    height: 100%;
    width: 100%;
    border-radius: 0.3rem;
    position: absolute;
    top: 0;
    background-color: #e2e2e2;
    animation: loading .5s infinite alternate;
  }
}
@keyframes loading {
  from {background-color:#b8b3b3;}
  to {background-color: hsl(0, 5%, 78%);}
}

.subtitle {
  margin-top: 10px;
  font-size: 12px;
  font-weight: 600;
  color: black;
  margin-bottom: 8px;
}

.divider {
  position: relative;
  height: 1px;
}
.div-transparent:before {
  content: "";
  position: absolute;
  top: 0;
  left: 5%;
  right: 5%;
  width: 90%;
  height: 1px;
  opacity: 0.2;
  background-image: linear-gradient(to right, transparent, rgb(48,49,51), transparent);
}

.stick-button {
  width: 100px;
}
.button:focus, .button.is-focused {
  box-shadow: 0 0 0 0.125em rgba(10, 10, 10, 0.25) !important;
  -webkit-box-shadow: 0 0 0 0.125em rgba(10, 10, 10, 0.25) !important;
}
</style>
